import { IPropertyAddressFormData, IPropertyAddressReturnValue } from "types/address/IPropertyAddressFormData";
import { isNil } from "lodash";

const EMPTY_ADDRESS_CONSTANT = 4;
const requiredFields: (keyof IPropertyAddressFormData)[] = ['streetAddress', 'city', 'stateAbbreviation', 'zipCode'];

export const convertToPropertyAddressData = (
    formData: IPropertyAddressFormData,
  ): IPropertyAddressReturnValue => {
    const missingFields: string[] = [];
  
    requiredFields.forEach(field => {
      if (isNil(formData[field])) {
        missingFields.push(field);
      }
    });
  
    return {
      address: {
        streetAddress: formData.streetAddress || '',
        unit: formData.unit || '',
        city: formData.city || '',
        stateAbbreviation: formData.stateAbbreviation || '',
        zipCode: formData.zipCode || '',
        createdAt: '',
        updatedAt: '',
        id: '',
      },
      missingFields,
      isEmpty: missingFields?.length === EMPTY_ADDRESS_CONSTANT,
    };
  };